'use client'

import { useParams, usePathname, useRouter } from 'next/navigation'
import { ReactNode } from 'react'
import getUrlPrefix from '@/utils/getUrlPrefix'
import { InternalLinkRecord } from '@/graphql/types'
import { ObviousLinkFragment } from '@/components/DatoLink/ObviousLink.generated'
import InternalLink from '@/components/DatoLink/InternalLink'
import { InternalLinkFragment } from '@/components/DatoLink/InternalLink.generated'

type ObviousLinkProps = {
	fragment: ObviousLinkFragment
	children: ReactNode
	id?: string
	className?: string
	style?: { [key: string]: string | number }
	inactive?: boolean
	params?: string
	onClick?: React.MouseEventHandler<HTMLAnchorElement>
	locale?: string
}

export default function ObviousLink({ children, ...props }: ObviousLinkProps) {
	const { fragment, className, style, params, locale } = props
	const { lang } = useParams()
	const { push } = useRouter()
	const pathname = usePathname()

	const isHomePage =
		pathname === `/${locale || lang}` || pathname === `/${locale || lang}/`

	const handleClick = () => {
		push(
			`/${locale || lang}${getUrlPrefix(fragment as any as InternalLinkRecord)}${params ? params : ''}`,
		)
	}

	if (isHomePage) {
		return (
			<InternalLink
				{...props}
				fragment={fragment as any as InternalLinkFragment}
			>
				{children}
			</InternalLink>
		)
	}

	return (
		<span
			onClick={handleClick}
			className={`${className || ''} cursor-pointer`}
			style={style}
		>
			{children}
		</span>
	)
}
